export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5009.08da434b.jpg";